import { Copy } from 'lucide-react';
import EthereumHexString from './EthereumHexString';
import { NetworkAvatar } from './legacy/network-avatar';
import NetworkAccountAvatar from './NetworkAccountAvatar';
import NetworkAccountDateAdded from './NetworkAccountDateAdded';
import NetworkAccountExplorer from './NetworkAccountExplorer';
import NetworkName from './NetworkName';
import { Button } from './ui/button';
import { HoverCard, HoverCardContent, HoverCardTrigger } from './ui/hover-card';
import { CopyToClipboard } from './v2/copy-to-clipboard';

interface Props {
  symbol?: string;
  address?: string;
}

export default function NetworkAccount({ symbol, address }: Props) {
  return (
    <HoverCard openDelay={300}>
      <HoverCardTrigger>
        <button type="button" className="flex items-center">
          <NetworkAccountAvatar
            symbol={symbol}
            address={address}
            diameter={24}
            className="w-6 h-6 mr-1"
          />
          <span className="font-mono underline decoration-dashed decoration-gray-300 underline-offset-4 truncate">
            <EthereumHexString value={address} />
          </span>
        </button>
      </HoverCardTrigger>
      <HoverCardContent className="w-96">
        <div className="flex flex-col space-y-4 py-2">
          <div className="flex items-center text-gray-900 text-lg font-medium">
            <NetworkAccountAvatar
              symbol={symbol}
              address={address}
              diameter={24}
              className="w-6 h-6 mr-1"
            />
            <span className="font-mono">
              <EthereumHexString value={address} diameter={24} />
            </span>
          </div>
          <div className="grid grid-cols-2 gap-4 text-sm indent-1">
            <dl className="space-y-0.5">
              <dt className="text-gray-400 font-normal">Date Added</dt>
              <dd className="text-gray-900 font-medium">
                <NetworkAccountDateAdded symbol={symbol} address={address} />
              </dd>
            </dl>
            <dl className="space-y-0.5">
              <dt className="text-gray-400 font-normal">Network</dt>
              <dd className="text-gray-900 font-medium">
                <NetworkAvatar
                  symbol={symbol}
                  className="w-4 h-4 mr-1 inline-block align-middle"
                />
                <span className="align-middle">
                  <NetworkName symbol={symbol} />
                </span>
              </dd>
            </dl>
          </div>
          <div className="flex gap-4">
            <CopyToClipboard text={address}>
              <Button variant="secondary" size="sm">
                <Copy className="w-4 h-4 mr-2" />
                Copy Address
              </Button>
            </CopyToClipboard>
            <NetworkAccountExplorer symbol={symbol} address={address} />
          </div>
        </div>
      </HoverCardContent>
    </HoverCard>
  );
}
// export default function NetworkAccount({ symbol, address, ...props }: Props) {
//   return (
//     <Popover
//       content={
//         <div className="flex flex-col space-y-4 py-2">
//           <div className="flex items-center text-gray-900 text-lg font-medium">
//             <NetworkAccountAvatar
//               symbol={symbol}
//               address={address}
//               diameter={24}
//               className="w-6 h-6 mr-1"
//             />
//             <span className="font-mono">
//               <EthereumHexString value={address} diameter={24} />
//             </span>
//           </div>
//           <div className="grid grid-cols-2 gap-4 text-sm indent-1">
//             <dl className="space-y-0.5">
//               <dt className="text-gray-400 font-normal">Date Added</dt>
//               <dd className="text-gray-900 font-medium">
//                 <NetworkAccountDateAdded symbol={symbol} address={address} />
//               </dd>
//             </dl>
//             <dl className="space-y-0.5">
//               <dt className="text-gray-400 font-normal">Network</dt>
//               <dd className="text-gray-900 font-medium">
//                 <NetworkAvatar
//                   symbol={symbol}
//                   className="w-4 h-4 mr-1 inline-block align-middle"
//                 />
//                 <span className="align-middle">
//                   <NetworkName symbol={symbol} />
//                 </span>
//               </dd>
//             </dl>
//           </div>
//           <div className="grid grid-cols-2 gap-4">
//             <CopyToClipboard
//               text={address ?? ''}
//               onCopy={() => {
//                 Message.success('Copied to clipboard');
//               }}
//             >
//               <button
//                 type="button"
//                 className="px-2 py-1.5 bg-gray-50 hover:bg-gray-100 rounded text-gray-500"
//               >
//                 <IconCopy className="mr-1" />
//                 Copy address
//               </button>
//             </CopyToClipboard>
//             <NetworkAccountExplorer symbol={symbol} address={address} />
//           </div>
//         </div>
//       }
//       {...props}
//     >
//       <button type="button" className="flex items-center">
//         <NetworkAccountAvatar
//           symbol={symbol}
//           address={address}
//           diameter={24}
//           className="w-6 h-6 mr-1"
//         />
//         <span className="font-mono underline decoration-dashed decoration-gray-300 underline-offset-4">
//           <EthereumHexString value={address} />
//         </span>
//       </button>
//     </Popover>
//   );
// }
